import React, { useEffect, useState } from 'react';
import moment from 'moment';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { FiMail, FiTrash2, FiArrowLeft, FiPlus } from 'react-icons/fi';
import services from '../../services';
import DeleteModal from '../../utils/deleteModal/deleteModal';
import ImapAuthUser from './index';

const ImapMailboxTable = () => {
    const navigate = useNavigate();
    const [mailboxes, setMailboxes] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [addStatus, setAddStatus] = useState(false);
    const [showModalDelete, setShowModalDelete] = useState(false);
    const [selectDeleteId, setSelectDeleteId] = useState('');

    useEffect(() => {
        getAllMailboxes();
    }, []);

    const getAllMailboxes = async () => {
        setIsLoading(true);
        try {
            const response = await services.imapEmail.LIST();
            const list = response?.data?.data || response?.data || [];
            setMailboxes(Array.isArray(list) ? list : []);
        } catch (error) {
            console.error(error);
            toast.error('Failed to load webmail accounts');
        } finally {
            setIsLoading(false);
        }
    };

    const handleDelete = async () => {
        try {
            await services.imapEmail.DELETE(selectDeleteId);
            toast.success('Webmail account removed');
            getAllMailboxes();
        } catch (error) {
            console.error(error);
            toast.error(error?.response?.data?.message || 'Failed to remove account');
        }
    };

    const handleConfirm = () => {
        setShowModalDelete(false);
        handleDelete();
    };

    return (
        <div style={{ padding: '20px' }}>
            <div className="imap-page-header">
                <div className="imap-page-title-row">
                    <button
                        className="imap-icon-btn-back"
                        onClick={() => navigate('/app')}
                        aria-label="Back"
                        data-tooltip-id="my-tooltip"
                        data-tooltip-content="Back"
                    >
                        <FiArrowLeft size={16} />
                    </button>
                    <div className="imap-page-icon">
                        <FiMail size={18} color="#fff" />
                    </div>
                    <div>
                        <div className="imap-page-title">Webmail Accounts</div>
                        <div className="imap-page-subtitle">Connected mailboxes for this company</div>
                    </div>
                    <span className="imap-count-badge">{mailboxes.length}</span>
                </div>
                <div style={{ display: 'flex', gap: '10px' }}>
                    <button className="imap-btn-primary" onClick={() => setAddStatus(true)}>
                        <FiPlus size={14} style={{ marginRight: '6px', verticalAlign: 'middle' }} />
                        Add Webmail
                    </button>
                </div>
            </div>

            <div className="imap-table-wrapper">
                <table className="imap-table">
                    <thead>
                        <tr className="imap-thead-row">
                            <th className="imap-th" style={{ width: '48px' }}>No.</th>
                            <th className="imap-th">Name</th>
                            <th className="imap-th">Email</th>
                            <th className="imap-th">IMAP Host</th>
                            <th className="imap-th">SMTP Host</th>
                            <th className="imap-th">Connected On</th>
                            <th className="imap-th" style={{ textAlign: 'center' }}>Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {mailboxes && mailboxes.length > 0 ? (
                            mailboxes.map((item, index) => (
                                <tr className="imap-row" key={item.id || item._id}>
                                    <td className="imap-td" style={{ color: '#9ca3af', fontWeight: 600 }}>{index + 1}</td>
                                    <td className="imap-td">
                                        <div className="imap-name-cell">
                                            <div className="imap-avatar">{(item?.name || item?.email || '?').charAt(0).toUpperCase()}</div>
                                            <span style={{ fontWeight: 500, color: '#111827' }}>{item?.name || '-'}</span>
                                        </div>
                                    </td>
                                    <td className="imap-td"><span className="imap-email-chip">{item?.email}</span></td>
                                    <td className="imap-td" style={{ color: '#6b7280' }}>{item?.imapHost || '-'}</td>
                                    <td className="imap-td" style={{ color: '#6b7280' }}>{item?.smtpHost || '-'}</td>
                                    <td className="imap-td" style={{ color: '#6b7280' }}>{item?.createdAt ? moment(item.createdAt).format('DD MMM YYYY') : '-'}</td>
                                    <td className="imap-td" style={{ textAlign: 'center' }}>
                                        <button
                                            className="imap-icon-btn-danger"
                                            data-tooltip-id="my-tooltip"
                                            data-tooltip-content="Disconnect Mailbox"
                                            onClick={() => {
                                                setShowModalDelete(true);
                                                setSelectDeleteId(item.id || item._id);
                                            }}
                                        >
                                            <FiTrash2 size={14} />
                                        </button>
                                    </td>
                                </tr>
                            ))
                        ) : (
                            !isLoading && (
                                <tr>
                                    <td colSpan={7}>
                                        <div className="imap-empty-state">
                                            <FiMail size={32} color="#d1d5db" />
                                            <p>No webmail accounts connected yet</p>
                                        </div>
                                    </td>
                                </tr>
                            )
                        )}
                    </tbody>
                </table>
            </div>

            {showModalDelete && (
                <DeleteModal
                    showModal={showModalDelete}
                    handleCloseModal={() => setShowModalDelete(false)}
                    handleConfirm={handleConfirm}
                    confirmButtonName="Delete"
                    title="Remove Webmail Account"
                    message="Are you sure you want to disconnect this mailbox?"
                />
            )}

            {addStatus && (
                <ImapAuthUser
                    imapStatus={addStatus}
                    onClose={() => setAddStatus(false)}
                    onConnected={getAllMailboxes}
                />
            )}
        </div>
    );
};

export default ImapMailboxTable;
